@if (navigationFooters?.length > 0) {
  <sd-navigation-footer
    [ngClass]="'is-' + currentBrandSkp"
    [navigationFooter]="navigationFooters"
    [contact]="contact"
    [location]="location"
    [themesConfig]="themesConfig"
    [review]="contentReview"
    [serviceOptions]="serviceOptions"
    [brand]="activeBrand"
  />
}
